import React from 'react';
import SettingsText from '../settings-text';
import CallForwardingSettingsContent from './call-forwarding-settings-content';

const CallForwardingSettings: React.FC = () => (
  <div id="call-forwarding" className="settings-wrapper call-forwarding-settings">
    <SettingsText title="Set Call Forwarding Rule" description="Set whom should the call be transferred to when you are not able to pick up the call in browser." />
    <CallForwardingSettingsContent />
  </div>
);

export default CallForwardingSettings;